import { CoreContainerItem } from '@adobe/aem-core-components-react-spa'

export type cqItems = {
  [key: string]: CoreContainerItem
}

export type UDOTypes = {
  campaign?: string
  campaignSession?: string
  campaignCodeInternal?: string
  campaignCodeInternalSession?: string
  promoCode: string
  visitorType: string
  visitorServiceability: string
  cBillPay3Days: string
  cCHLEligible: boolean
  cEasyPayEnroll: boolean
  cPaperlessEnrolled: boolean
  cMobilePhone: boolean
  cMobilePhoneVerified: boolean
  cTcPendOrder: boolean
  cSrPendOrder: boolean
  cInsPendOrder: boolean
  cPendShipment: boolean
  cPendPickup: boolean
  moveAddressCapture: boolean
  zip?: string
  pAddressActive: boolean
  pAddressCapture: boolean
  pAddressStreet: string
  pAddressZip: string
  pAddressApartment: string
  pHouseNumber: string
  moveAddressActive: boolean
  moveToApt: string
  moveToStreet: string
  moveToZip: string
  moveToHouseNumber: string
  moveToSiteID: string
  mfaEnrolled: boolean
  pCoxMdmRequest: boolean
  zipGeo: string
  error: string
  serviceableCodes: string
  siteID: string
  franchiseId: string
  localeName: string
}

export enum ContentType {
  static = 'static',
  dynamic = 'dynamic',
  copy = 'copy'
}

export enum ScreenSizes {
  XS = 0,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
  XXL = 1400
}

export enum LobExperience {
  BUSINESS = 'business',
  RESIDENTIAL = 'residential',
}

export enum CoxThemeClass {
  BUSINESS = 'cox-busi',
  RESIDENTIAL = 'cox-resi',
}

export enum DynamicBannerStatus {
  ERROR = 'error',
  SUCCESS = 'success',
  PENDING = 'pending'
}

export enum DeviceVariation {
  MOBILE = 'mobile',
  DESKTOP = 'desktop'
}

export enum AddressServiceabilityStatus {
  serviceableActive = 'SERVICEABLE-ACTIVE',
  serviceable = 'SERVICEABLE',
  exceedsThreshold = 'EXCEEDSTHRESHOLD',
  multiple = 'MULTIPLE',
  nonServiceable = 'NONSERVICEABLE',
  unknown = 'UNKNOWN',
  cbonlyaddress = 'CBONLYADDRESS',
  default = 'default'
}

export interface Flexoffers {
  offers: Offer[]
  discounts: Discount[]
  cinfos: any // converting to array to maintian consistency
  success: boolean
  loading: boolean
  error: boolean
}

export interface NonProspectResponse {
  propositions: Propositions
  success: boolean
}

export interface Propositions {
  offers: Offer[]
  discounts: Discount[]
}

export interface Discount {
  amount: number
  quantity: number
  subsidy: boolean
  dueNow: boolean
  descriptionKey: string
  promotionCodes: string[]
  dynamicDetails: string
  occurrence: number
  duration: number
  delay: number
  campaigns?: Campaign[]
  name: string
  id: string
  discountDurationType: string
  isSubsidy: boolean
  discountKeyFeatures?: Feature[]
}

export interface Campaign {
  customerType: string
  icomsCampaign: boolean
  value: string
}

export interface Feature {
  name: string
  value: string
}

export interface Cinfo {
  listTotalAmount: string
  netTotalAmount: string
  internet: Internet
}

export interface Internet {
  subscribedAdditionalFeatures: SubscribedAdditionalFeatures
  name: string
  subscribedOptions: string[]
  serviceCategory: string
}

export interface SubscribedAdditionalFeatures {
  hsiRepackValueProp: string
}

export interface Offer {
  totalPromotionalMonthlyCharges: number
  totalPromotionalMonthlyPriceCents: string
  featured: boolean
  calcDollarAndCentsSavings: string
  totalPromotionalMonthlyPriceDollars: string
  contentId: string
  offerFeatures: OfferFeature[]
  isBreakableOffer: boolean
  isTopBundle: boolean
  optionalChannelGroupsEnabled: boolean
  termsAndConditions: TermsAndCondition[]
  existingEquipmentTotalPromotionalCharges: number
  totalOneTimeCharges: number
  totalRegularMonthlyPriceDollars: string
  calcPercentSavings: string
  offerAdditionalFeatures: Feature[]
  existingEquipmentTotalRegularCharges: number
  totalOneTimeChargesCents: string
  breakableOffer: boolean
  id: string
  totalRegularMonthlyPriceCents: string
  endingPromotionalTerm: number
  totalOneTimeChargesDollars: string
  basePromotionalMonthlyCharges: number
  startingPromotionalTerm: number
  offerCategories: OfferCategory[]
  totalRegularMonthlyCharges: number
  descriptionKey: string
  totalAdditionalRequiredMonthlyCharges: number
  offerExperiences: string[]
  promotionCodes: string[]
  services: Service[]
  promotionalPricingDetail: string[]
  calcDollarSavings: string
  equipmentPromotionalMonthlyCharges: number
  offerKeyFeatures: Feature[]
  discountIds: string[]
  totalSubscriptionDeltaAmount: number
  regularPriceText: string
  calcCentsSavings: string
  contractTerm: number
  name: string
  surcharges: number
  regularOneTimeCharges: number
  offerHighlights: OfferHighlight[]
}

export interface OfferCategory {
  sequence: number
  categoryName: string
}

export interface OfferFeature {
  name: string
  serviceCategory: ServiceCategory
  value?: string
}

export enum ServiceCategory {
  HomeSecurity = 'HomeSecurity',
  Internet = 'Internet',
  Telephone = 'Telephone',
  Television = 'Television'
}

export interface OfferHighlight {
  serviceCategory: ServiceCategory
  promotional: boolean
  textKey: string
}

export interface Service {
  depositAmount: number
  totalPromotionalMonthlyCharges: number
  totalRegularMonthlyCharges: number
  contentId: string
  optionGroups: OptionGroup[]
  serviceCategory: ServiceCategory
  existingEquipmentTotalPromotionalCharges: number
  totalOneTimeCharges: number
  existingEquipmentTotalRegularCharges: number
  name: ServiceCategory
  offerId: string
  regularOneTimeCharges: number
  id: string
}

export interface OptionGroup {
  min: number
  systemName: string
  max: number
  maxQuantity: number
  contentId: string
  options: Option[]
  name: string
  descriptionKey?: string
  location: string
  id: string
  type: string
  controlType?: string
}

export interface Option {
  includedQuantity: number
  originalPrice: number
  maxQuantity: number
  dueNow: boolean
  regularPrice: number
  cartDeltaAmount: number
  contentId: string
  promotionalPrice: number
  financeAmount: number
  availableDate: string
  subscriptionDeltaAmount: number
  subscribed: boolean
  unitDepositAmount: number
  productImageURLs?: string[]
  unmodifiable: boolean
  instanceRegularPrices?: number[]
  systemName: string
  mediumName: string
  subscribedQuantity: number
  unsubscribe: boolean
  complex: boolean
  id: string
  instancePromotinalPrices?: number[]
  selected: boolean
  spreadEnabled: boolean
  depositAmount: number
  allowsUnsubscribe: boolean
  financeDownPayment: number
  quantity: number
  priceType: string
  descriptionKey: string
  depositSpread: number
  spread: number
  discountIds?: string[]
  highlights?: Highlight[]
  name: string
  partNumber: string
  estimatedTaxesAndFees: number
  location?: string
}

export interface Highlight {
  text: string
}

export interface TermsAndCondition {
  title: string
  textKey: string
}

export enum RuleType {
  udoconditional = 'udoconditional',
  conditional = 'conditional',
  pricing = 'pricing',
  token = 'token'
}

export enum CustomerType {
  PROSPECT = 'prospect',
  CUSTOMER = 'customer',
  PINPOINT = 'pinpoint'
}

export enum VisitorType {
  NONCUSTOMER = 'noncustomer',
  CUSTOMER = 'customer'
}

export type FormStateType = {
  [key: string]: {
    value: string | object
    isRequired?: boolean
    status?: DynamicBannerStatus
    inputType?: string
    parameters?: boolean
  }
}

export interface RuleBuilderPayload {
  customerType?: string
  appcontext?: string
  includeExactServices?: boolean
  maxOffers?: number
  intent?: string
  products?: string
  includeSubscribedServiceCategories?: boolean
  offerIds?: string
  lob?: string
}
export enum GeoLocationType {
  outOfMarket = 'outOfMarket',
  invalid = 'invalid',
  cbOnlyMarket = 'cbOnlyMarket',
  inMarket = 'inMarket'
}

export enum ReactComponents {
  REACT_ACCORDION = 'ReactAccordion',
  REACT_ADDRESSCAPTURE = 'ReactAddressCapture'
}
